import * as actionTypes from "../actions/actionTypes";

const initialState = {
  showRegisterCompany: false,
  showSuccessModal: false,
  isSentEmailContact: false,
  showSuccessModalCreateLinkVoucher: false,
  showErrorModalCreateLinkVoucher: false,
  showMessage: ''
};

const landingReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case actionTypes.TOGGLE_REGISTER_COMPANY:
      return {
        ...state,
        showSuccessModal: false,
        showRegisterCompany: actions.toggle
      };
    case actionTypes.SUCCESS_SEND_EMAIL_REGISTER_COMPANY:
      return {
        ...state,
        showRegisterCompany: false,
        showSuccessModal: true
      };
    case actionTypes.TOGGLE_SEND_EMAIL_CONTANT:
      return {
        ...state,
        isSentEmailContact: actions.toggle
      };
    case actionTypes.REQUEST_SUCCESS_CREATE_VOUCHER:
      return {
        ...state,
        showSuccessModalCreateLinkVoucher: true,
        showMessage: actions.message
      };
    case actionTypes.REQUEST_FAILED_CREATE_VOUCHER:
      return {
        ...state,
        showErrorModalCreateLinkVoucher: true,
        showMessage: actions.message
      };
    case actionTypes.CLOSE_MODAL_SUCCESS_CREATE_LINK_VOUCHER:
      return {
        ...state,
        showSuccessModalCreateLinkVoucher: false
      };
    case actionTypes.CLOSE_MODAL_ERROR_CREATE_LINK_VOUCHER:
      return {
        ...state,
        showErrorModalCreateLinkVoucher: false
      };
    default:
      return state;
  }
};

export default landingReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/landingReducer.js